<template>
  <div :class="['container', _isMobile() ? 'mobile' : 'mobileNo']">
    <Header/>
    <div class="BreadcrumbBox" v-if="!_isMobile() && routeObj.meta.title"> <router-link :to="{ path: '/' }">首页</router-link> <span> <a-icon type="right" />{{ routeObj.meta.title }}</span></div>

    <!-- <HomeSideMenu/> -->
    <!-- <div class="banner-wrap">
      <img class="banner-bg" style="" src="../assets/banner-bg1.png" alt="">
    </div> -->
    <a-page-header  @back="() => $router.back()" style="width: 1360px;margin: 20px auto;" v-if="routeObj.meta.pageHeader && !_isMobile()">
      <div slot="backIcon" style="font-size: 14px;color: #323335;"><a-icon type="left" />返回 &nbsp; |</div>
      <div slot="title" style="font-size: 14px;font-weight: 600;color: #323335;">{{ $route.query.name }}</div>
    </a-page-header>
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
    <Footer v-if="!_isMobile()" />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeSideMenu from '../components/HomeSideMenu';

export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Footer,
    HomeSideMenu
  },
  watch:{
    $route:{
      handler(val,oldval){
        this.routeObj = val
      },
      // 深度观察监听
      deep: true,
      immediate:true
    }
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
      routeObj:{}
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig && tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>
<style>
  a *{
    transition: all 0.1s ease;
  }
</style>
<style lang="less" scoped>
.container {
  background: #f2f6f8;
  .header{
    background: linear-gradient(to top, #52a7e300, #5261c7d9);
  }
  .banner-wrap {
    .banner-bg{
      z-index: -1;
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    max-width: 1200px;
    margin: 24px auto;
  }
  .mobileNo{
    background: url(../assets/aice2/page_background.jpg);
    background-size: 100% 100%;
    .home {
      max-width: 1200px;
      margin: 80px auto 20px;
      padding: 20px;
      background: #ffffff4a;
      border-radius: 30px;
    }
    /deep/.ant-list-pagination {
      text-align: center;
    }
  }
  
  // background: url(../assets/bg.png);
  // background-position: top;
 
}
</style>